var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgMoon = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentcolor",
  fillRule: "evenodd",
  clipRule: "evenodd",
  viewBox: "0 0 16 16",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M7.564 1.694a.75.75 0 0 1-.024.837 4.25 4.25 0 0 0 5.929 5.929.75.75 0 0 1 1.174.743A6.752 6.752 0 0 1 1.25 8a6.752 6.752 0 0 1 5.547-6.643.75.75 0 0 1 .767.337zm-2.087 1.7a5.25 5.25 0 1 0 7.128 7.128 5.75 5.75 0 0 1-7.128-7.128z"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgMoon);
export default ForwardRef;